export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "model": {
          "estimated_container": {
            "week": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Semana"])},
            "num_containers": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Número de contenedores"])}
          }
        }
      }
    }
  })
}